import React, {useEffect, useRef, useState} from "react";

interface WinFireDropDownProps <T>{
    buttonText: string;
    elements: WinFireDropDownElement<T>[];
    elementFilter: (filter: string, filterObj: T) => boolean;
}

export interface WinFireDropDownElement<T>{
    key: string;
    selectFunction: (obj: T) => void;
    text: string;
    sourceObject: T;
}

const WinFireDropDown = <T,>({buttonText, elements, elementFilter}:WinFireDropDownProps<T>) => {
    const dropdownRef: React.RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);

    const [showDropDown, setShowDropDown] = useState(false);
    const [filterText, setFilterText] = useState('');

    useEffect(() => {
        const handleClickAway = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowDropDown(false); // Close the dropdown if clicking outside
            }
        };

        document.addEventListener('mousedown', handleClickAway);

        return ()=>{
            document.removeEventListener('mousedown', handleClickAway);
        }
    }, []);

    return <div className="dropdown" ref={dropdownRef}>
        <button className="btn btn-primary"
                onClick={() => setShowDropDown(!showDropDown)}>{buttonText}
            <span className={"bi-caret-down"}/></button>
        <div className={showDropDown ? "dropdown-content dropdown-show" : "dropdown-content"} style={{zIndex: 10000}}>
            <div className="input-group">
                <input className="form-control border-end-0 border" type="text"
                       id="example-search-input" onChange={(evt) => {
                    setFilterText(evt.currentTarget.value);
                }}
                       value={filterText} autoComplete={"off"}/>
                <span className="input-group-append">
                                                <button
                                                    className="btn btn-outline-secondary bg-white border-start-0 border ms-n3"
                                                    type="button">
                                                    <i className="bi bi-search"></i>
                                                </button>
                                            </span>
            </div>
            {
                elements.filter(c => elementFilter(filterText, c.sourceObject)).map((c) => {
                    return <a key={c.key}
                              onClick={() => {
                                  setShowDropDown(false);
                                  c.selectFunction(c.sourceObject)
                              }}>{c.text}</a>
                })
            }
        </div>
    </div>
}

export default WinFireDropDown;